import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

import { CalendarEventsFilterRanges } from '../../../sic-lib/enums/CalendarEventsFilterRanges';
import { GenericReducer, genericReducer } from '../../../sic-lib/reducers/genericReducer';
import { Contact } from '../../../sic-lib/types/Contact';
import SelectDateRangeFilter from '../../Settings/ClientFields/SelectDateRangeFilter/SelectDateRangeFilter';
import DrawerEditCalendarEvent from '../DrawerEditCalendarEvent/DrawerEditCalendarEvent';
import DrawerNewCalendarEvent from '../DrawerNewCalendarEvent/DrawerNewCalendarEvent';
import DrawerOpenCalenderSchedule from '../DrawerOpenCalenderSchedule/DrawerOpenCalenderSchedule';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: '100%',
    },
    actionWrapper: {
        flexBasis: '48px',
    },
    scrollWrapper: {
        height: 'calc(100% - 48px)',
        overflow: 'hidden',
    },
    button: {
        color: theme.palette.addButton.main,
        '&:hover': {
            backgroundColor: theme.palette.addButton.light,
        },
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

interface ContactEventsListState {
    rangeFilter: CalendarEventsFilterRanges;
}

interface Props {
    contact: Contact;
}

export default function ContactCalendarEventsList({ contact }: Props) {
    const { classes } = useStyles();

    const [showScheduler, setShowScheduler] = React.useState<boolean>(false);
    const handleToggleScheduler = () => setShowScheduler(!showScheduler);

    const [eventsListState, onEventsListStateChange] = React.useReducer<
        GenericReducer<ContactEventsListState>
    >(genericReducer, {
        rangeFilter: CalendarEventsFilterRanges.today,
    });

    return (
        <React.Fragment>
            <Grid container direction="column" wrap="nowrap" className={classes.root}>
                <Grid item xs="auto" className={classes.actionWrapper}>
                    <Grid container direction="row">
                        <Grid item xs={true}>
                            <SelectDateRangeFilter
                                className={classes.formControl}
                                value={eventsListState.rangeFilter}
                                onSelectHandler={onEventsListStateChange}
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Button
                                className={classes.button}
                                onClick={handleToggleScheduler}
                                startIcon={<AddIcon />}
                            >
                                Schedule event
                            </Button>
                        </Grid>
                    </Grid>
                    <DrawerOpenCalenderSchedule
                        isOpen={showScheduler}
                        toggleCloseHandler={handleToggleScheduler}
                    />
                </Grid>
                <Grid item xs={true} className={classes.scrollWrapper}>
                    <div className="scrollWrapper--hideScrollbar">
                        {/* <ContactCalendarEventsFiltered
                                calendarEvents={calendarEventsResult}
                                rangeFilter={eventsListState.rangeFilter}
                            /> */}
                    </div>
                </Grid>
            </Grid>
            <DrawerEditCalendarEvent />
            <DrawerNewCalendarEvent contact={contact} />
        </React.Fragment>
    );
}
